/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown> }} Social_Export_Meta_ConnectedInputs */

const cs_social_export_meta_connected = /** @type {(inputs: Social_Export_Meta_ConnectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Propojeno: ${i?.page}`)
};

const en_social_export_meta_connected = /** @type {(inputs: Social_Export_Meta_ConnectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connected: ${i?.page}`)
};

/**
* | output |
* | --- |
* | "Connected: {page}" |
*
* @param {Social_Export_Meta_ConnectedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_meta_connected = /** @type {((inputs: Social_Export_Meta_ConnectedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Meta_ConnectedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_meta_connected(inputs)
	return cs_social_export_meta_connected(inputs)
});